import { render, staticRenderFns } from "./retorno.vue?vue&type=template&id=fed7b8de"
import script from "./retorno.vue?vue&type=script&lang=js"
export * from "./retorno.vue?vue&type=script&lang=js"
import style0 from "./retorno.vue?vue&type=style&index=0&id=fed7b8de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports